import React from 'react'
import PropTypes from 'prop-types'
import { Grid, IconButton } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import SydButton from '../../../../../../../commonDesign/Button'
import SydSelect from '../../../../../../../commonDesign/SydSelect'

const SORT_DIR_OPTIONS = [
  { label: 'Ascending', value: 'asc' },
  { label: 'Descending', value: 'desc' }
]

function DefaultSortEditor ({
  localConfig,
  setLocalConfig,
  sortFieldOptions,
  onAddSort,
  onRemoveSort,
  onUpdateSort
}) {
  const defaultSort = localConfig.defaultSort || []
  const columns = localConfig.columns || []

  return (
    <Grid item xs={12}>
      <div style={{ marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '8px' }}>
        <h4 style={{ margin: 0 }}>Default Sort Order</h4>
        <SydButton
          size='sm'
          icon='add'
          onClick={onAddSort}
          disabled={columns.length === 0}
        >
          Add Sort
        </SydButton>
      </div>
      {defaultSort.map((sort, index) => (
        <div key={index} style={{ display: 'flex', gap: '8px', alignItems: 'center', marginBottom: '8px' }}>
          <div style={{ flex: 1 }}>
            <SydSelect
              options={sortFieldOptions}
              value={sort.field}
              onChange={(e) => onUpdateSort(index, 'field', e.target.value)}
              placeholder='Select field'
            />
          </div>
          <div>
            <SydSelect
              options={SORT_DIR_OPTIONS}
              value={sort.dir}
              onChange={(e) => onUpdateSort(index, 'dir', e.target.value)}
            />
          </div>
          <IconButton size='small' onClick={() => onRemoveSort(index)}>
            <DeleteIcon fontSize='small' />
          </IconButton>
        </div>
      ))}
      {defaultSort.length === 0
        ? (
          <p style={{ color: 'var(--text-color-subtle)', fontSize: '0.875rem', margin: 0 }}>
            No default sort configured
          </p>
        )
        : null}
    </Grid>
  )
}

DefaultSortEditor.propTypes = {
  localConfig: PropTypes.object.isRequired,
  setLocalConfig: PropTypes.func.isRequired,
  sortFieldOptions: PropTypes.arrayOf(PropTypes.shape({ label: PropTypes.string, value: PropTypes.string })).isRequired,
  onAddSort: PropTypes.func.isRequired,
  onRemoveSort: PropTypes.func.isRequired,
  onUpdateSort: PropTypes.func.isRequired
}

export default DefaultSortEditor
